import CreanceVueProduits from '@/components/comptable/creance/creance-vue-produits'
import CreanceVuePatients from '@/components/caisse/factures/creance-patients'
import CreanceFactures from '@/components/comptable/creance/creance-factures'
import CreanceForfaitaires from '@/components/comptable/creance/creance-forfaitaire'
import CreanceConsoReelles from '@/components/comptable/creance/creance-conso-reelles'
import Prestation from "@/components/comptable/prestations-exploitations/prestation"
import PrintFactureAssurance from '@/components/comptable/creance/print-facture-assurance'

export default {
    name: 'creance',
    components: {
        CreanceVueProduits, CreanceVuePatients, CreanceFactures, Prestation,
        CreanceForfaitaires, PrintFactureAssurance, CreanceConsoReelles
    },
    props: [],
    data() {
        return {
            config_to_show: 'vue-produits',

            is_recap: true,
            montant_en_lettre: '',
            montant_total: 0,
            can_print: false,
            is_month: false,
            liste_produits_creances: [],
            current_date_filter: {},
            curr_month: "",

            is_assurance_bill: false,
            selected_facture: {},
            view_by_societe: [],
            view_patients: [],
            total_facture: 0,
            total_en_lettre: '',
            selected_view: '',
            print_toggler: 0,
            type_facture: ''
        }
    },

    computed: {
        
    },

    mounted() {
        
    },

    methods: {
        changeTab(tab_to_show) {
            this.config_to_show = tab_to_show
        },

        printCreances(print_data) {
            this.is_recap = print_data.is_recap
            this.can_print = true
            this.liste_produits_creances = print_data.liste_produits_creances
            this.montant_total = print_data.montant_total
            this.montant_en_lettre = print_data.montant_en_lettre
            this.current_date_filter = print_data.current_date_filter
            this.is_month = print_data.is_month
            this.curr_month = print_data.curr_month

            setTimeout(() => {
                window.print()
                this.can_print = false
            }, 500);
        },

        setPrintFactureAssurance(invoice_data) {
            this.print_toggler = (this.print_toggler == 0)?1:0
            this.is_assurance_bill = invoice_data.is_assurance_bill
            this.selected_facture = invoice_data.selected_facture
            this.view_by_societe = invoice_data.view_by_societe
            this.view_patients = invoice_data.view_patients
            this.total_facture = invoice_data.total_facture
            this.total_en_lettre = invoice_data.total_en_lettre
            this.selected_view = invoice_data.selected_view
            this.type_facture = 'facture_assurance'
        },

        setPrintFactureSociete(invoice_data) {
            console.log(">> to print 3",invoice_data);
            this.print_toggler = (this.print_toggler == 0)?1:0
            this.selected_facture = invoice_data.selected_facture
            this.total_facture = invoice_data.total_facture
            this.total_en_lettre = invoice_data.total_en_lettre
            this.type_facture = 'facture_forfaitaire'
        }
    }
}